import { Button as ButtonAntd } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const colors = {
  green: '#55B349',
  white: '#FFFFFF',
  blue: '#467BB2',
  gray: '#676A6C',
  third: '#728591',
};

export const Button = styled(ButtonAntd)`
  border: 1px solid #55b349 !important;
  font-weight: bolder;
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
`;

export const Styles = createGlobalStyle`
  .btnAtivo {
    color: ${colors.white} !important;
    background: ${colors.green} !important;

    &:hover {
      color: ${colors.white} !important;
    }
  }

  .btnInativo {
    color: ${colors.green} !important;
    background: ${colors.white} !important;

    &:hover {
      color: ${colors.green} !important;
    }
  }
`;
